import { useState } from "react";
import useFetch from "../../../hooks/useFetch";
import { ServiceEvents } from "../shared/interfaces";
import { buildEndpoint } from '../EndPoints';
import { GroupActionDataForm } from "../../models/Action";


const useActionService = () => {

    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [ fetchingGetActions, setFetchingGetActions ] = useState(false);
    const [ fetchingEditActionsByGroup, setFetchingEditActionsByGroup ] = useState(false);
    const [ fetchingUpdateActionsByGroup, setFetchingUpdateActionsByGroup ] = useState(false);

    const BASE_PATH = 'actions/actions';

    const getActions = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/`),
            setFetching: setFetchingGetActions
        });
    };

    const editActionsByGroup = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/edit-by-group`),
            setFetching: setFetchingEditActionsByGroup
        });
    };

    const updateActionsByGroup = (id: number, actions: GroupActionDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/update-by-group`),
            body: actions,
            setFetching: setFetchingUpdateActionsByGroup
        });
    };

    return {
        fetchingGetActions,
        fetchingEditActionsByGroup,
        fetchingUpdateActionsByGroup,
        getActions,
        editActionsByGroup,
        updateActionsByGroup
    }

}

export default useActionService;